package br.com.texeratx.boardgametimeapp.ui.screens.players

import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayersUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.players.create.CreatePlayerState
import br.com.texeratx.boardgametimeapp.ui.screens.players.model.PlayerListItemUI
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class PlayersViewModel(
    private val getPlayers: GetPlayersUseCase,
) : ScreenModel {

    private var allPlayers: List<PlayerListItemUI> = emptyList()

    val state = MutableStateFlow(PlayersUiState())
    val createState = MutableStateFlow(CreatePlayerState())
    val isCreating = MutableStateFlow(false)


    fun loadPlayers() {
        screenModelScope.launch {
            state.value = state.value.copy(isLoading = true, error = null)

            getPlayers().fold(
                onSuccess = {
                    allPlayers = it
                    applyFiltersAndSort()
                },
                onFailure = {
                    state.value = state.value.copy(
                        isLoading = false,
                        error = it.message
                    )
                }
            )
        }
    }

    fun dismissError() {
        state.value = state.value.copy(error = null)
    }

    fun onSearch(query: String) {
        state.value = state.value.copy(searchQuery = query)
        applyFiltersAndSort()
    }

    fun updateFilters(filters: PlayersFilter) {
        state.value = state.value.copy(filters = filters)
        applyFiltersAndSort()
    }

    fun changeSort(sort: PlayerSortOption) {
        state.value = state.value.copy(sort = sort)
        applyFiltersAndSort()
    }

    private fun applyFiltersAndSort() {
        val currentState = state.value
        val query = currentState.searchQuery.trim()
        val filters = currentState.filters

        val filteredPlayers = allPlayers
            .filter { player ->
                val hasNickname = !player.nickname.isNullOrBlank()

                val matchesSearch = query.isBlank() ||
                        player.name.contains(query, ignoreCase = true) ||
                        (player.nickname?.contains(query, ignoreCase = true) == true)

                val matchesNickname = when {
                    filters.withNickname && filters.withoutNickname -> true
                    filters.withNickname -> hasNickname
                    filters.withoutNickname -> !hasNickname
                    else -> true
                }

                val matchesPhoto = !filters.withPhoto || !player.imageUrl.isNullOrBlank()

                matchesSearch && matchesNickname && matchesPhoto
            }
            .let { players ->
                when (currentState.sort) {
                    PlayerSortOption.NAME_ASC -> players.sortedBy { it.name.lowercase() }
                    PlayerSortOption.NAME_DESC -> players.sortedByDescending { it.name.lowercase() }
                }
            }

        state.value = state.value.copy(
            players = filteredPlayers,
            isLoading = false
        )
    }

    fun updateCreateState(newState: CreatePlayerState) {
        createState.value = newState
    }
}
